import { Vertical, VERTICALS, VERTICAL_ID } from './Vertical';

export enum PRODUCT_ID {
	MINECRAFT = 'modding',
	ROBLOX = 'roblox',
	BUNDLE = 'bundle'
}

export enum SINGLE_PRODUCT_ID {
	MINECRAFT = 'modding',
	ROBLOX = 'roblox'
}

export class Product {
	readonly id: PRODUCT_ID;
	readonly name: string;
	private readonly verticals: Vertical[];

	constructor(id: PRODUCT_ID, name: string, verticals: Vertical[]) {
		this.id = id;
		this.name = name;
		this.verticals = verticals;
	}

	includes(vertical: Vertical) {
		return this.verticals.indexOf(vertical) !== -1;
	}
}

export const PRODUCTS = {
	[PRODUCT_ID.MINECRAFT]: new Product(PRODUCT_ID.MINECRAFT, 'Minecraft Coding', [
		VERTICALS[VERTICAL_ID.MINECRAFT]
	]),
	[PRODUCT_ID.ROBLOX]: new Product(PRODUCT_ID.ROBLOX, 'Roblox Coding', [
		VERTICALS[VERTICAL_ID.ROBLOX]
	]),
	[PRODUCT_ID.BUNDLE]: new Product(PRODUCT_ID.BUNDLE, 'Bundle', [
		VERTICALS[VERTICAL_ID.MINECRAFT],
		VERTICALS[VERTICAL_ID.ROBLOX]
	])
};
